import { AxiosResponse } from 'axios';
import { FilterOptions } from '../../hooks/useFilters';
import { RestServiceConnection } from '../restServiceConnection';

const CLIENT_ENDPOINT = '/client';

export class ClientService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el listado de clientes
     *
     * @EN Gets the list of clients
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    listClients = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: CLIENT_ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene la información de un cliente por su ID
     *
     * @EN Gets the information of a client by its ID
     * 
     * @param clientId
     */
    // -------------------------------------------------------------------------------------------------------------
    getClientById = async (clientId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: CLIENT_ENDPOINT + '/get',
            data: { id: clientId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Crea un cliente con la información proporcionada
     *
     * @EN Creates a client with the provided information
     * 
     * @param client
     */
    // -------------------------------------------------------------------------------------------------------------
    createClient = async (client: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: CLIENT_ENDPOINT + '/create',
            data: client,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Edita un cliente con la información proporcionada
     *
     * @EN Edits a client with the provided information
     * 
     * @param client
     */
    // -------------------------------------------------------------------------------------------------------------
    editClient = async (client: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: CLIENT_ENDPOINT + '/edit',
            data: client,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Elimina un cliente existente en el sistema
     *
     * @EN Deletes an existing client from the system
     *
     * @param ids
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteClient = async (ids: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: CLIENT_ENDPOINT + '/delete',
            data: { ids: [ids] },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Elimina varios clientes existentes en el sistema
     *
     * @EN Deletes multiple existing clients from the system
     * 
     * @param clientIds
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiClients = async (clientIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: CLIENT_ENDPOINT + '/delete',
            data: { ids: clientIds }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    //-------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el listado de facturas de un cliente
     *
     * @EN Gets the list of invoices of a client
     * 
     * @param filters
     */
    //-------------------------------------------------------------------------------------------------------------
    listClientInvoices = async (filters: FilterOptions) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: CLIENT_ENDPOINT + '/list-invoices',
            data: filters,
        }, true);
        return this;
    }
    //-------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE USUARIOS
     * @EN GETS THE LIST OF USERS
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: CLIENT_ENDPOINT + '/list-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}